import { ServiceException } from '@uzurv/rideWss/app/exceptions';

export class UserNotFoundException extends ServiceException {}
